
























































import { Component, Emit, Prop, Vue, Ref } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import * as c_Interface from '@/interface/components/manageGroups';
import { GroupItem } from '@/interface/store/manageGroups';

const namespace: string = 'manageGroup';

@Component
export default class ModalMember extends Vue {
  @Prop({ type: Boolean, default: false }) dialogVisible!: boolean;
  @Prop({ type: Boolean, default: false }) isAdmin!: boolean;
  @Getter('getterGroupsMemberships', { namespace }) readonly c_getterGroupsMemberships!: any;
  @Action('setMembers', { namespace }) c_setMembers!: any;
  @Ref('item') formItem!: Array<HTMLFormElement>;

  // 관리자면 초대 상태, 멤버면 초대 대기 상태
  public status = this.isAdmin ? 'INVITED' : 'REQUESTED';
  public propsDialogVisible = this.dialogVisible;
  // 빈 초대 이메일 슬롯 3개로 고정
  public memberList: Array<c_Interface.Member> = [
    { email: '', isAdmin: false, status: this.status },
    { email: '', isAdmin: false, status: this.status },
    { email: '', isAdmin: false, status: this.status },
  ];
  public isValidate = true;
  public rules = {
    email: [
      { type: 'email', message: '유효한 이메일 주소가 아닙니다.', trigger: ['blur', 'change'] },
    ],
  };
  public isLoading = false;

  get currentGroupName() {
    const groupId = this.$route.params.groupId;
    return this.c_getterGroupsMemberships.length > 0
      ? this.c_getterGroupsMemberships.find((v: GroupItem) => v.fkGroup.id === groupId).fkGroup.name
      : [];
  }

  @Emit('emitModalClose')
  modalClose(): boolean {
    this.propsDialogVisible = false;
    return this.propsDialogVisible;
  }

  addMember(): void {
    this.memberList.push({
      email: '',
      isAdmin: false,
      status: this.status,
    });
  }

  validateAll(): void {
    let validationCount: number = 0;

    for (let i = 0; i < this.memberList.length; i += 1) {
      this.formItem[i].validate((valid: boolean) => {
        if (!valid) {
          this.isValidate = false;
        } else validationCount += 1;
      });
    }

    if (validationCount === this.memberList.length) this.isValidate = true;
  }

  async inviteSubmit(): Promise<void> {
    const groupId: string = this.$route.params.groupId;
    // 빈 email 항목들 필터
    const members = this.memberList.filter((member: any) => {
      return member.email !== '';
    });

    await this.validateAll();

    if (this.isValidate) {
      // 초대할 멤버 없을경우 api 진행 안함
      if (members.length) {
        try {
          this.isLoading = true;
          await this.c_setMembers({
            groupId,
            payload: members,
          });
          this.$message.success('초대 이메일을 발송하였습니다.');
          this.isLoading = false;
          this.$emit('emitInviteSubmit', false);
        } catch (e) {
          this.isLoading = false;
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('입력된 이메일이 없습니다.');
      }
    } else {
      this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
    }
  }
}
